export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_PROD = process.env.NODE_ENV === 'production';
let _SHOULD_LOG = {
  value: IS_DEV
};
export const SHOULD_LOG = () => _SHOULD_LOG.value;
if (localStorage.getItem('SHOULD_LOG') === '') {
  _SHOULD_LOG.value = true;
}
Object.freeze(_SHOULD_LOG);